const EUR = new Intl.NumberFormat("fr-FR", {
  style: "currency",
  currency: "EUR",
  maximumFractionDigits: 0,
});
const NUM = new Intl.NumberFormat("fr-FR");

export const euro = (v: number) => EUR.format(v);
export const num = (v: number) => NUM.format(v);
export const pricePerM2 = (v: number) => `${NUM.format(Math.round(v))} €/m²`;

/** Percentage change, signed, e.g. "+4.2%" / "−11.7%". */
export function pctChange(from: number, to: number): string {
  const pct = ((to - from) / from) * 100;
  const sign = pct > 0 ? "+" : pct < 0 ? "−" : "";
  return `${sign}${Math.abs(pct).toFixed(1)}%`;
}

/** A rate as a signed percentage, e.g. "+2.4%" / "−1.1%". */
export function pct(rate: number): string {
  const v = rate * 100;
  const sign = v > 0 ? "+" : v < 0 ? "−" : "";
  return `${sign}${Math.abs(v).toFixed(1)}%`;
}

/**
 * Euros at a glance: "412 k€", "1.24 M€".
 *
 * Property prices are six and seven figures, and full precision on an axis
 * label or a comparison row is noise — the reader is comparing magnitudes.
 */
export function euroShort(v: number): string {
  const abs = Math.abs(v);
  if (abs >= 1_000_000) return `${(v / 1_000_000).toFixed(2)} M€`;
  if (abs >= 10_000) return `${Math.round(v / 1000)} k€`;
  return EUR.format(v);
}

/**
 * Counts of people or homes at a glance: "1.4 M", "138 k", "820".
 *
 * Population figures span four orders of magnitude across the region — a
 * hamlet of 300 and a department of 1.6 million sit on the same axis — and
 * full precision on a tick label is noise.
 */
export function countShort(v: number): string {
  const abs = Math.abs(v);
  if (abs >= 1_000_000) return `${(v / 1_000_000).toFixed(2)} M`;
  if (abs >= 10_000) return `${Math.round(v / 1000)} k`;
  if (abs >= 1_000) return `${(v / 1000).toFixed(1)} k`;
  return NUM.format(Math.round(v));
}
